<template>
	<div class="page">
		<div class="pageTitleBox">
			<div class="boxNameL">
				关联订金订单
			</div>
			<div class="boxNameR">
				<el-button type="warning" @click="$router.back()" size="small">返回</el-button>
			</div>
		</div>
		<div class="pageConBox">
			<el-table :data="list" style="width: 100%">
				<el-table-column prop="no" label="销售订单" width="130">
				</el-table-column>
				<el-table-column label="类型" width="70">
					<template slot-scope="scope">
						{{scope.row.order_type_id==1?'商品':''}}
						{{scope.row.order_type_id==2?'洗美':''}}
						{{scope.row.order_type_id==3?'病例':''}}
						{{scope.row.order_type_id==4?'疫苗驱虫':''}}
						{{scope.row.order_type_id==5?'医疗服务':''}}
						{{scope.row.order_type_id==6?'寄养':''}}
						{{scope.row.order_type_id==7?'挂号':''}}
						{{scope.row.order_type_id==8?'活体':''}}
						{{scope.row.order_type_id==9?'虚拟类':''}}
						{{scope.row.order_type_id==10?'订金':''}}
					</template>
				</el-table-column>
				<el-table-column label="结算金额" width="90">
					<template slot-scope="scope">
						{{(scope.row.total_price).toFixed(2)}}
					</template>
				</el-table-column>
				<el-table-column prop="zip" label="结算状态" width="70">
					<template slot-scope="scope">
						{{$public.formatOrderState(scope.row.state)}}
					</template>
				</el-table-column>
				<el-table-column prop="zip" label="结算方式">
					<template v-if="scope.row.pay_info" slot-scope="scope">
						<div v-for="(item,index) in scope.row.pay_info.pay_list" :key="index">
							<span style="padding-right: 2px;">
								{{$public.formatPayTypeState(item.pay_type)}}
							</span>
							{{Math.abs((item.money).toFixed(2))}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="订单备注" width="80">
					<template slot-scope="scope">
						<el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.remark">
							<div slot="reference" style="width:80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">{{scope.row.remark}}</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column label="结算备注">
					<template v-if="scope.row.pay_info" slot-scope="scope">
						<el-popover placement="top-start" width="200" trigger="hover" :content="scope.row.pay_info.pay_remark">
							<div slot="reference" style="width:80px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;cursor: pointer;">{{scope.row.pay_info.pay_remark}}</div>
						</el-popover>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="120">
					<template slot-scope="scope">
						<el-button @click="$router.push({path:'/dingdan/saleOrderSee',query:{id:scope.row._id}})" type="text" size="small">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				list:[],
				
			}
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getDetail();
		},
		methods: {
			getDetail(){
				let loading = this.$loading()
				let params = {
					orderNos: this.$route.query.str,
					filter:false, // true:过滤   false:不过滤
				}
				this.$http.get('/api/Order/GetOrderListByOrderNos', params).then(res => {
					loading.close()
					if(res.code===0){
						this.list = res.data;
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	.pageTitleBox{
	}
	.msg {
		display: flex;
		flex-wrap: wrap;
		background-color: #fff;
		border-radius: 4px;
		.msgItem {
			width: 25%;
			font-size: 16px;
			color: $fontColor;
			display: flex;
			line-height: 40px;
			padding:0 20px;
			box-sizing: border-box;
			border-bottom:1px solid #F2F2F2;
			font-size: 12px;;
			.msgLabel {
				width: 80px;
				text-align: right;
				color: $fontColor;
			}
	
			.msgValue {}
		}
	}
	.pageConBox{
		min-height: 600px;
		margin-top:12px;
	}
}
</style>
